export default `query($token: String!, $courseId: String!, $courseIds: [String], $primaryCourseId: String!, $isBundlingCourse: Boolean,$isPhysicalDeliveryEnabled: Int, $deliveryFee: Float,$ocvmId: Int, $bundlingId: Int, $optedAddOn: Int) {
    primaryCourseId: constant(value: $primaryCourseId)
  withAuth(token: $token) {
    user{
      region
  language
coursePrice(courseIds: $courseIds, primaryCourseId:$primaryCourseId, isBundlingCourse: $isBundlingCourse, isPhysicalDeliveryEnabled:$isPhysicalDeliveryEnabled,deliveryFee:$deliveryFee,ocvmId: $ocvmId,bundlingId: $bundlingId, optedAddOn: $optedAddOn) {
  id
handlingFactor
ifFeeHandledByTutor
redeemableAmount
discount
price
name
igst
taxGSTValue
isTaxEnabled
isPhysicalDeliveryEnabled
deliveryFee
isDeliveryFeeHandledByTutor
bundlingCourseMeta
recommDiscountPer
recommDiscountAmt
platformFee
addOns {
          addOn
          amountType
          amountValue
          name
       }
platformFeeBelowCutOff
}
  student {
        hashCoupons : coupons(limit:1,offset: 0,isPhysicalDeliveryEnabled:$isPhysicalDeliveryEnabled){
          id
    }
    inVisibleCouponCount(courseId: $courseId,isPhysicalDeliveryEnabled:$isPhysicalDeliveryEnabled)
  }
  redeems(courseIds: $courseIds, state: CLAIMED) {
        id
    coupon {
          id
      code
      name
      amount
      discountType
      couponType
      maxAmount
      totalLimit
      userLimit
      startDateTime
      endDateTime
      courseIds
      totalRedeem: redeemCount(notInState: REVERSED,isTotalCount: true)
      redeemCount(notInState: REVERSED,isTotalCount: false)
      isApplicableToAllCourses
    }
  }
}
}
}
mapper<safejs-
const isPhysicalDeliveryEnabled = data.withAuth.user.coursePrice && data.withAuth.user.coursePrice[0] && data.withAuth.user.coursePrice[0].isPhysicalDeliveryEnabled || 0
const deliveryFee = data.withAuth.user.coursePrice && data.withAuth.user.coursePrice[0] && data.withAuth.user.coursePrice[0].deliveryFee || 0
const isDeliveryFeeHandledByTutor = data.withAuth.user.coursePrice && data.withAuth.user.coursePrice[0] && data.withAuth.user.coursePrice[0].isDeliveryFeeHandledByTutor || 0
const hashCoupon = data.withAuth.user.student.hashCoupons.length > 0;
const coupon = data.withAuth.user.redeems && data.withAuth.user.redeems.length ? [data.withAuth.user.redeems[0].coupon] : null;
const inVisibleCouponCount = data.withAuth.user.student.inVisibleCouponCount;
const redeemId = data.withAuth.user.redeems && data.withAuth.user.redeems.length ? data.withAuth.user.redeems[0].id : null;
data = courseOverviewDynamic(coupon, data.withAuth.user.coursePrice, 0, true, hashCoupon,data.primaryCourseId, inVisibleCouponCount, data.withAuth.user.region,data.withAuth.user.language,'','',isPhysicalDeliveryEnabled,deliveryFee,isDeliveryFeeHandledByTutor,null,data.withAuth.user.coursePrice[0].bundlingCourseMeta, data.withAuth.user.coursePrice[0].addOns);
if(redeemId){
  data.label.redeemId = redeemId
 data.coupons[0].coupon.redeemId = redeemId

}
-js>`;
